<template>
  <el-dialog
    title="从模板中导入栏目"
    :visible.sync="dialogVisible"
    width="400px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <div class="import-content">
      <p style="margin-bottom: 20px; color: #606266;">请选择要导入的栏目模板：</p>
      
      <el-checkbox-group v-model="selectedTemplates" @change="handleTemplateChange">
        <div v-for="template in templateList" :key="template.id" class="template-item">
          <el-checkbox :label="template.id">{{ template.name }}</el-checkbox>
        </div>
      </el-checkbox-group>
      
      <div v-if="selectedTemplates.length > 0" class="preview-section">
        <h4>预览导入的栏目：</h4>
        <ul class="preview-list">
          <li v-for="template in previewTemplates" :key="template.id">
            {{ template.name }}
          </li>
        </ul>
      </div>
    </div>
    
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="handleImport">
        导入栏目
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { importProductColumns } from '@/api/custom-frontend'

export default {
  name: 'ImportColumnDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    appInfo: {
      type: Object,
      required: true
    },
    existingColumns: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      submitLoading: false,
      selectedTemplates: [],
      templateList: [
        { id: 1, name: '意外险', note: '各类意外保险产品' },
        { id: 2, name: '健康险', note: '健康医疗保险产品' },
        { id: 3, name: '寿险', note: '人寿保险产品' },
        { id: 4, name: '财产险', note: '财产保险产品' },
        { id: 5, name: '车险', note: '机动车保险产品' },
        { id: 6, name: '旅游险', note: '旅游保险产品' },
        { id: 7, name: '企业险', note: '企业团体保险产品' },
        { id: 8, name: '农业险', note: '农业保险产品' },
        { id: 9, name: '其他保险', note: '其他类型保险产品', children: [
          { id: 10, name: '宠物险', parent_id: 9, note: '宠物保险产品' },
          { id: 11, name: '运动险', parent_id: 9, note: '运动保险产品' },
          { id: 12, name: '特殊险种', parent_id: 9, note: '特殊险种产品' }
        ]}
      ]
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    
    previewTemplates() {
      return this.templateList.filter(template => 
        this.selectedTemplates.includes(template.id)
      )
    }
  },
  methods: {
    handleTemplateChange(value) {
      // 如果选择了"其他保险"，自动选择其子项
      if (value.includes(9)) {
        const childIds = [10, 11, 12]
        childIds.forEach(id => {
          if (!this.selectedTemplates.includes(id)) {
            this.selectedTemplates.push(id)
          }
        })
      }
      
      // 如果取消了"其他保险"，也取消其子项
      if (!value.includes(9)) {
        this.selectedTemplates = this.selectedTemplates.filter(id => ![10, 11, 12].includes(id))
      }
    },
    
    async handleImport() {
      if (this.selectedTemplates.length === 0) {
        this.$message.warning('请选择要导入的栏目模板')
        return
      }
      
      this.submitLoading = true
      
      try {
        // 构建导入数据
        const importData = []
        const flatTemplateList = this.getFlatTemplateList()
        
        this.selectedTemplates.forEach(templateId => {
          const template = flatTemplateList.find(t => t.id === templateId)
          if (template) {
            // 检查是否已存在同名栏目
            const existingColumn = this.existingColumns.find(col => col.name === template.name)
            if (!existingColumn) {
              importData.push({
                id: 0,
                name: template.name,
                parent_id: template.parent_id || 0,
                type: 3,
                app_id: this.appInfo.id,
                note: template.note,
                sort: template.id * 10, // 简单的排序规则
                disabled: false,
                logo_url: ''
              })
            }
          }
        })
        
        if (importData.length === 0) {
          this.$message.warning('选择的栏目已全部存在，无需导入')
          return
        }
        
        const res = await importProductColumns(importData)
        if (res && res.err_code === 0) {
          this.$message.success(`成功导入${importData.length}个栏目`)
          this.$emit('refresh')
          this.handleClose()
        } else {
          this.$message.error(res.err_msg || '导入失败')
        }
      } catch (error) {
        console.error('导入栏目失败:', error)
        this.$message.error('导入失败')
      } finally {
        this.submitLoading = false
      }
    },
    
    getFlatTemplateList() {
      const flatList = []
      this.templateList.forEach(template => {
        flatList.push(template)
        if (template.children) {
          template.children.forEach(child => {
            flatList.push(child)
          })
        }
      })
      return flatList
    },
    
    handleClose() {
      this.dialogVisible = false
      this.selectedTemplates = []
    }
  }
}
</script>

<style lang="less" scoped>
.import-content {
  .template-item {
    margin-bottom: 10px;
    padding: 8px;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    
    &:hover {
      background-color: #f5f7fa;
    }
  }
  
  .preview-section {
    margin-top: 20px;
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 4px;
    
    h4 {
      margin: 0 0 10px 0;
      color: #303133;
    }
    
    .preview-list {
      margin: 0;
      padding-left: 20px;
      
      li {
        margin-bottom: 5px;
        color: #606266;
      }
    }
  }
}
</style>